import { MenuItem, TextField } from '@material-ui/core'

import type { deadline } from '../..'
import { FORM_TEXT } from '../ExtensionModal'
import type { formErrors, formVals } from '../ExtensionModal'

type props = {
  formValues: formVals
  handleInputsChange: (name: string, value: string | Date | number) => void
  formErrors: formErrors
  deadlines: deadline[]
}
const Deadline = ({ formValues, formErrors, deadlines, handleInputsChange }: props) => {
  return (
    <TextField
      required
      id="extensionDeadlineId"
      variant="outlined"
      select
      value={formValues.deadlineId ?? ''}
      error={formErrors.deadlineId ? true : false}
      helperText={formErrors.deadlineId ?? ''}
      FormHelperTextProps={{ role: 'alert' }}
      name="deadlineId"
      label={FORM_TEXT.deadlineLabel}
      onChange={(e) => handleInputsChange(e.target.name, e.target.value)}
    >
      {deadlines.map((option) => (
        <MenuItem
          key={option.Id}
          value={option.Id}
        >
          {option.Name}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default Deadline
